export default __webpack_public_path__ + "static/media/yourdevice.6055d684.png";